import React, { useEffect, useState, useRef } from 'react';
export function ContactCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.2
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <section className="py-32 px-6" style={{
    backgroundColor: 'var(--bg-dark)'
  }} data-id="element-13">
      <div ref={ref} className="max-w-6xl mx-auto transition-all duration-700 ease-out" style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(24px)'
    }} data-id="element-14">
        <h2 className="leading-[1.1] tracking-tight mb-6" style={{
        color: '#F7F5F0',
        fontFamily: 'var(--font-heading)',
        fontSize: 'var(--text-display)',
        fontWeight: 'normal',
        maxWidth: '75%'
      }} data-id="element-15">
          Ready to build
          <br data-id="element-16" />
          something great?
        </h2>

        <p className="leading-relaxed mb-12" style={{
        color: 'rgba(247,245,240,0.6)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-body)',
        fontWeight: '400',
        maxWidth: '60%'
      }} data-id="element-17">
          We'd love to hear about your product. Reach out and let's talk about
          how we can help.
        </p>

        <a href="https://calendly.com/danielle-abc/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-7 py-3.5 rounded-full transition-all duration-200 hover:opacity-80" style={{
        backgroundColor: '#F7F5F0',
        color: 'var(--bg-dark)',
        fontFamily: 'var(--font-sans)',
        fontSize: '0.875rem',
        fontWeight: '600'
      }} data-id="element-18">
          Book now
        </a>
      </div>
    </section>;
}